import * as Sentry from '@sentry/react';
import posthog from 'posthog-js';
import { env } from './env';

export function initMonitoring() {
  if (env.sentryDsn && env.isProd) {
    Sentry.init({
      dsn: env.sentryDsn,
      integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
      tracesSampleRate: 0.1,
      replaysSessionSampleRate: 0.0,
      replaysOnErrorSampleRate: 1.0,
    });
  }

  if (env.posthogKey) {
    posthog.init(env.posthogKey, {
      api_host: env.posthogHost,
      capture_pageview: false, // we'll track manually with router
      person_profiles: 'identified_only',
    });
  }
}

export function trackEvent(name: string, props?: Record<string, unknown>) {
  if (env.posthogKey) {
    posthog.capture(name, props);
  }
}

export function identifyUser(userId: string, traits?: Record<string, unknown>) {
  if (env.posthogKey) {
    posthog.identify(userId, traits);
  }
  if (env.sentryDsn) {
    Sentry.setUser({ id: userId });
  }
}

export function resetUser() {
  if (env.posthogKey) posthog.reset();
  if (env.sentryDsn) Sentry.setUser(null);
}
